import React, { useEffect, useRef, useState } from 'react'
import { Button, Dimmer, Form, Loader, Select } from 'semantic-ui-react'
import 'styled-components/macro'
import { useHistory } from 'react-router'
import ProgressBar from './progressbar-freelancer'
import axios from '../../axios'
import { useTranslation } from 'react-i18next'
import { astyles } from '../paypalsettingsbuttonstyles'
import Navbar from '../../shared/navbar/navbar'
import Footer from '../../shared/footer/footer'
import { useDispatch, useSelector } from 'react-redux'
import env from '../../config.env'
import { Link } from 'react-router-dom'
import { userActions } from '../../store/user-slice'
import { uiActions } from '../../store/ui-slice'
import { url_environment_2 } from '../../config'
const { paypalRedirectURL } = env
const LanguageOptions = [
    { key: "en", value: "en", text: "English" },
    { key: "es", value: "es", text: "Español" }
]


const BusinessProfile = () => {
    const { userInfo } = useSelector(state => state.user)
    const [Loading, setLoading] = useState(true)
    const [btnLoading, setBtnLoading] = useState(false)
    const [btnLoading2, setBtnLoading2] = useState(false)
    const [t, i18n] = useTranslation("global")
    const [Language, setLanguage] = useState(i18n.language)
    const [QRCode, setQRCode] = useState(false)
    const dispatch = useDispatch()
    const handleLanguageChange = (e, { value }) => {
        setLanguage(value)
    }
    const history = useHistory()
    useEffect(() => {
        loadData()
    }, [])
    const config = {
        headers: {
            Authorization: `Bearer ${userInfo.token}`,
        },
    }
    const loadData = async () => {
        try {
            setLoading(true)
            const { data: qrcode } = await axios.post("/api/user/qrcode", {}, config)
            setQRCode(qrcode)
            setLoading(false)
        } catch (e) {
            alert(e)
            setLoading(false)
        }
    }
    const paypalurl = paypalRedirectURL + encodeURIComponent(url_environment_2 + "/paypal-verify-2")
    const handleGenerateToken = async () => {
        try {
            setBtnLoading(true)
            let { data } = await axios.post("/api/user/generateToken", {}, config)
            setBtnLoading(false)
            setQRCode(data)
        } catch (e) {
            alert(e)
            setBtnLoading(false)
        }
    }
    const handleSave = async () => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${userInfo.token}`,
                },
            }
            await axios.post("/api/user/language", {
                id_language: Language,
                language: Language == "en" ? "English" : "Español"
            }, config)
            i18n.changeLanguage(Language);
            localStorage.setItem("languageValue", Language)
            dispatch(userActions.updateValues({ name: "id_language", value: Language }))
        } catch (e) { alert(e) }
    }
    const handleDeleteToken = async () => {
        try {
            setBtnLoading2(true)
            let { data } = await axios.post("/api/user/deleteToken", {}, config)
            setBtnLoading2(false)
            setQRCode("no secret")
        } catch (e) {
            alert(e)
            setBtnLoading2(false)
        }
    }
    const handleReportProblemClick = () => {
        dispatch(uiActions.change_action({ open: true, action: "report a problem" }))
    }
    if (Loading) {
        return (
            <Dimmer active inverted>
                <Loader />
            </Dimmer>
        )
    }
    return (
        <>
            <Navbar />
            <main>

                <div className="ui container">
                    <ProgressBar active={6} />
                </div>
                <h2 css="text-align:center;">{t("profile.Settings")}</h2>
                <div className="ui grid container">
                    <div css="margin:1rem;"><p css="font-size:0.75rem;color:#db2828;font-weight:bold;">{t("warning_tfa_2.1")}<a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">Google Authenticator</a>{t("warning_tfa_2.2")}</p></div>
                    <div css="display:flex;flex-wrap:wrap;max-width:1000px;justify-content:center;">
                        <div css="flex:0 0 auto;max-width:210px;width:20%;padding:10px;@media(max-width:550px){width:100%;}">
                            <form className="ui form">
                                <a /*onClick={handlePaypalClick}*/ css="margin-bottom:20px !important;" target="_blank" css={astyles} css="font-size: 13px;font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;font-weight: 700;padding: 6px;" href={paypalurl}>
                                    <svg class="PPTM" xmlns="http://www.w3.org/2000/svg" version="1.1" width="25px" height="25px" viewBox="0 0 18 18" focusable="false"><path id="Fill-8" class="PPTM-btm" fill="#009cde" d="M13.6023044,4.67342223 C13.8196336,3.28812419 13.6008532,2.34542498 12.8514484,1.49160831 C12.0263956,0.551629995 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.43245482 2.3109822,0.817370681 L0.00598653054,15.4327457 C-0.0395473836,15.7211605 0.183405526,15.9818221 0.475294243,15.9818221 L3.89269613,15.9818221 L3.65686311,17.4774071 C3.61713431,17.7297247 3.81196867,17.957917 4.06739398,17.957917 L6.94782221,17.957917 C7.28887304,17.957917 7.57912907,17.7097715 7.63228221,17.3731061 L7.66058217,17.226722 L8.20317953,13.7860604 L8.23819166,13.5959605 C8.29134479,13.2591138 8.58160082,13.0111496 8.92247024,13.0111496 L9.35331903,13.0111496 C12.1439493,13.0111496 14.329033,11.8774436 14.9674148,8.59894727 C15.2342689,7.22906764 15.0963973,6.08556642 14.3908938,5.28163282 C14.1773742,5.03856625 13.9119713,4.83740146 13.6023044,4.67342223"></path><path id="Fill-9" class="PPTM-top" fill="#012169" d="M13.6023044,4.67384766 C13.8196336,3.28841937 13.6008532,2.34563151 12.8514484,1.49173456 C12.0263956,0.55166786 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.432481479 2.3109822,0.817433533 L0.00598653054,15.4341828 C-0.0395473836,15.7226247 0.183405526,15.9833109 0.475294243,15.9833109 L3.89269613,15.9833109 L4.75112833,10.5399219 L4.72446105,10.7106288 C4.78523341,10.3256767 5.11431118,10.0419515 5.50397989,10.0419515 L7.12832518,10.0419515 C10.3182389,10.0419515 12.815892,8.7459583 13.5457045,4.99802736 C13.5672923,4.88718584 13.5857961,4.7796097 13.6023044,4.67384766" fill-opacity="0.699999988079071"></path><path id="Fill-10" class="PPTM-top" fill="#003087" d="M5.67323544,4.69235148 C5.70988026,4.46069089 5.85845507,4.27111742 6.05855031,4.17515152 C6.14961814,4.13161312 6.25120775,4.10730418 6.35769543,4.10730418 L10.6968416,4.10730418 C11.2109576,4.10730418 11.6902429,4.14104644 12.128348,4.21161494 C12.2537024,4.23175145 12.3754285,4.25497193 12.4938892,4.28127638 C12.6121686,4.30739943 12.7271825,4.33678785 12.8383869,4.36944165 C12.8940797,4.38558714 12.9486841,4.40263969 13.0025629,4.42059928 C13.2177152,4.49189341 13.4179919,4.57624907 13.6023044,4.67384766 C13.8196336,3.28841937 13.6008532,2.34563151 12.8514484,1.49173456 C12.0263956,0.55166786 10.5359309,0.148937623 8.62894883,0.148937623 L3.09322219,0.148937623 C2.70355347,0.148937623 2.37175455,0.432481479 2.3109822,0.817433533 L0.00598653054,15.4341828 C-0.0395473836,15.7226247 0.183405526,15.9833109 0.475294243,15.9833109 L3.89269613,15.9833109 L5.67323544,4.69235148"></path></svg>
                                    PayPal
                                </a>
                                {userInfo.paypal_email && <p>Paypal email: {userInfo.paypal_email}</p>}
                                <div className="field">
                                    <label>{t("profile.Language")}</label>
                                    <Select placeholder={t("profile.Language")} defaultValue={i18n.language} options={LanguageOptions} onChange={handleLanguageChange} style={{ minWidth: "100%" }} />
                                </div>
                            </form>
                        </div>
                        <div css="flex:0 0 auto;width:20%;padding:10px;@media(max-width:550px){width:100%;}">
                            {QRCode != "no secret" && <div css="display:flex;flex-direction:column;align-items:center">
                                <Button circular css="background:rgb(2,183,178) !important;color:#fff !important;" loading={btnLoading2} onClick={handleDeleteToken}>{t('profile.delete_token')}</Button>
                                <img src={QRCode.qrcode} alt="" />
                                <p css="font-size:0.75rem;color:#db2828;font-weight:bold;">{t("warning_tfa")}</p>
                            </div>}
                            {QRCode == "no secret" && <div css="display:flex;flex-direction:column;align-items:center;">
                                <Button circular css="background:rgb(2,183,178) !important;color:#fff !important;" loading={btnLoading} onClick={handleGenerateToken}>{t('profile.generate_token')}</Button>
                            </div>}
                        </div>
                        <div css="flex:0 0 auto;width:20%;padding:10px;@media(max-width:550px){width:100%;}">
                            <div css="display:flex;flex-direction:column;align-items:center">
                                <Link to="marketing-packages"><Button circular css="background:rgb(0,128,129) !important;color:#fff !important;white-space: nowrap;" >{t('profile.marketing_packages')}</Button></Link>
                            </div>
                        </div>
                        <div css="flex:0 0 auto;width:20%;padding:10px;@media(max-width:550px){width:100%;}">
                            <div css="display:flex;flex-direction:column;align-items:center">
                                <Button onClick={handleReportProblemClick} circular css="background:rgb(2,183,178) !important;color:#fff !important;">{t('profile.report_problem')}</Button>
                            </div>
                        </div>
                        <div css="flex:0 0 auto;width:20%;padding:10px;@media(max-width:550px){width:100%;}">
                            <div css="display:flex;flex-direction:column;align-items:center">
                                <div>
                                    <Link to="/sent-proposals" className="ui circular teal button" style={{ background: "rgb(2,183,178)", whiteSpace: "nowrap" }}>{t('profile.contract_management')}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div css="display:flex;align-items:center;justify-content:space-between;max-width:1127px;margin:0 auto;margin-top:2rem;">
                    <button onClick={() => history.push("/freelancer-product")} className="ui circular primary button" css="background:rgb(82,219,212) !important;">
                        {t("profile.Back")}</button>
                    <button onClick={handleSave} className="ui circular primary button" css="background:rgb(2,183,178) !important;">
                        {t("profile.Save")}</button>
                </div>
            </main>

            <Footer />
        </>
    )
}

export default BusinessProfile

/**
 *
 * rgb(0,128,129)
rgb(2,183,178)
rgb(82,219,212)
 */